export default __webpack_public_path__ + "static/media/09-1.e5a70f85.jpg";